import { FC, useMemo } from 'react'

import { Badge } from '@/components'
import { ShiftExchangeStatus } from '@/models'
import { getShiftExchangeStatus } from '@/services/ShiftExchangeService/getShiftExchangeStatus'



interface ShiftExchangeBadgeProps {
    status: ShiftExchangeStatus
}

export const ShiftExchangeBadge: FC<ShiftExchangeBadgeProps> = ({ status }) => {
    const { color, text } = useMemo(() => getShiftExchangeStatus(status), [status])

    return (
        <Badge color={color} className="shift-exchange-badge">
            {text}
        </Badge>
    )
}
